<template>
  <div class="settle">
    <div class="settle-button__batch" @click="onBatch">批量结佣</div>

    <el-dialog title="结佣确认" :visible.sync="dialogVisible" modal-append-to-body append-to-body width="50%">
      <el-alert show-icon title="您正在提交结佣，请再次确认信息无误！" :closable="false" type="info"></el-alert>
      <div class="settle-tip__weight settle-tip__red settle-subtitle settle-subtitle__bottom">
        提交结佣后，系统将自动向达人的收款账户中下发佣金，同时将从您余额中扣除对应金额。
      </div>

      <!-- 表格 -->
      <el-table ref="table" v-loading="table.loading" :data="table.dataSource" border lazy row-key="userUUID" height="250"
        class="settle-table">
        <el-table-column prop="fansNickName" label="达人" width="280">
          <template slot-scope="{ row }">
            <div>
              {{ row.fansNickName }}
            </div>
            <div class="settle-tip">用户ID：{{ row.fansId }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="settledCnt" label="待结佣订单" width="280">
          <template slot-scope="{ row }">
            {{ row.settledCnt }}({{ row.settledAmount }})
          </template>
        </el-table-column>
        <el-table-column prop="settledCommission" label="佣金">
          <template slot-scope="{ row }">
            <div class="settle-tip__red">{{ row.settledCommission }}元</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页-->
      <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
        @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
        :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total">
      </el-pagination>

      <!-- 价格 -->
      <div class="settle-price">
        <div class="settle-price__num">
          <div>
            本次结佣金额：<span class="settle-tip__weight">{{ totalCommission }}元</span>
          </div>
          <div class="settle-price__my">
            我的余额：<span class="settle-tip__weight settle-tip__red">{{ balance }}元</span>
          </div>
        </div>
        <!-- 余额不足 -->
        <div v-if="diffNum < 0">
          <span class="settle-tip__red">余额不足 ({{ diffNum }}元)，请先</span>
          <span class="settle-tip__link" @click="goPath">前往充值</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="saveLoading" class="dialog-footer__button dialog-footer__sure" @click="onSure">确
          定</el-button>
        <el-button class="dialog-footer__button dialog-footer__cancel" @click="onCancel">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import douYin from "@/javaApi/douyin";
const DouYinModel = new douYin();
export default {
  props: {
    ids: {
      // ids的集合
      type: Array,
      default: () => [],
    },

    row: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      balance: 0, //我的余额
      totalCommission: 0, //本次结佣金额
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      table: {
        // 表格
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
      saveLoading: false, // 保存按钮
      dialogVisible: false, // 显示弹框
    };
  },
  computed: {
    diffNum() {
      // 差价
      return this.reduction(this.balance, this.totalCommission);
    },
  },
  methods: {
    // 相减
    reduction(a, b, precision = 2) {
      const p = Math.pow(10, precision);
      const result = (a * p - b * p) / p;
      return result.toFixed(precision);
    },
    // 计算表格数据
    freshTable() {
      this.table.loading = true;
      const list = [...this.batchList];
      this.table.dataSource = list.slice(
        (this.pagination.pageNo - 1) * this.pagination.pageSize,
        this.pagination.pageNo * this.pagination.pageSize
      );
      this.table.total = list.length;
      this.table.loading = false;
    },
    // 请求列表
    async freshList() {
      this.table.loading = true;
      const data = await DouYinModel.batchApplySettle({
        ids: this.ids,
      }).finally(() => {
        this.table.loading = false;
      });
      if (data.data.code === 200) {
        this.batchList = data.data.data.vos;
        this.balance = data.data.data.balance;
        this.totalCommission = data.data.data.totalCommission;
        this.freshTable();
      }
    },
    // 批量操作
    onBatch() {
      if (this.ids && this.ids.length) {
        this.dialogVisible = true;
        this.freshList();
      } else {
        this.$message.error("请先选择要结佣的数据");
      }
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 取消
    onCancel() {
      this.dialogVisible = false;
    },
    // 前往充值
    goPath() {
      const { href } = this.$router.resolve({
        path: "/pc/user/account",
        query: { recharge: true },
      });
      window.open(href, "_blank");
    },
    // 确定
    async onSure() {
      if (this.diffNum < 0) {
        this.$message.error("余额不足，请先充值");
        return;
      }
      if (this.ids && this.ids.length) {
        this.saveLoading = true;
        const data = await DouYinModel.batchSettle({
          ids: this.ids,
        }).finally(() => {
          this.saveLoading = false;
        });
        if (data.data.code === 200) {
          this.onCancel();
          this.$emit("refresh");
          this.$message.success(data.data.message);
        } else {
          this.$message.error(data.data.message);
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.settle {
  &-table {
    margin-bottom: 20px;
  }

  &-button {
    cursor: pointer;
    color: #ff8622;

    &__batch {
      width: 88px;
      height: 32px;
      background: #3d9efc;
      border-radius: 2px;
      color: #fff;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }

  &-tip {
    color: #999999;

    &__weight {
      font-weight: bold;
    }

    &__red {
      color: #ff4f76;
    }

    &__link {
      color: blue;
      cursor: pointer;
    }
  }

  &-price {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    &__num {
      display: flex;
    }

    &__my {
      margin-left: 30px;
    }
  }

  &-subtitle {
    &__bottom {
      margin-bottom: 20px;
    }
  }
}



/deep/.el-alert {
  background-color: #fff6f8 !important;
  color: #ff4f76 !important;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/distribution/BatchSettle.vue